import React from "react";
import "../styles/landing.css";

export const Landing = () => {
  return (
    <>
      <div className="hero-center-div">
        <div className="hero-content">
          <h1 className="hero-title valign-text-middle roboto-medium-white-48px">
            Your Daily Social Media Digest
          </h1>
          <div className="button-primary-hero">
            <div className="hero-text valign-text-middle roboto-normal-black-18px">
              <a href="/register">Register Here</a>
            </div>
          </div>
        </div>
        <div className="hero-overlap-group">
          <div className="browser border-className-1">
            <div className="img-group">
              <img
                className="button"
                src="https://anima-uploads.s3.amazonaws.com/projects/6067a6d9f6c618c698127565/releases/6067a7f704dbdf149481f145/img/button@2x.svg"
              />
              <img
                className="button"
                src="https://anima-uploads.s3.amazonaws.com/projects/6067a6d9f6c618c698127565/releases/6067a7f704dbdf149481f145/img/button@2x.svg"
              />
              <img
                className="button"
                src="https://anima-uploads.s3.amazonaws.com/projects/6067a6d9f6c618c698127565/releases/6067a7f704dbdf149481f145/img/button@2x.svg"
              />
            </div>
          </div>
          <img
            className="undraw-social-tionsrexcbi-1"
            src="https://anima-uploads.s3.amazonaws.com/projects/6067a6d9f6c618c698127565/releases/6067a7f704dbdf149481f145/img/undraw-social-notifications-re-xcbi-1-1@2x.svg"
          />
        </div>
      </div>

      {/* <!-- mid banner--> */}
      <div className="frame-1">
        <h1 className="frame-subtitle-1 roboto-normal-black-24px">
          All your social media notifications in one place
        </h1>
        <div className="frame-subtitle roboto-normal-black-20px">
          Top posts, stories, events and friend updates sent to you.
        </div>
      </div>

      {/* <!--upper split--> */}
      <div className="upper-feature-split-right">
        <div className="upper-overlap-group">
          <div className="upper-media">
            <div className="media-object"></div>
          </div>
          <div className="undrawdevelopapprebi4i-1">
            <img
              className="group-24"
              src="https://anima-uploads.s3.amazonaws.com/projects/6067a6d9f6c618c698127565/releases/6067a7f704dbdf149481f145/img/group-24@2x.svg"
            />
            <div className="overlap-group1">
              <img
                className="path-340"
                src="https://anima-uploads.s3.amazonaws.com/projects/6067a6d9f6c618c698127565/releases/6067a7f704dbdf149481f145/img/path-340@2x.svg"
              />
              <img
                className="vector"
                src="https://anima-uploads.s3.amazonaws.com/projects/6067a6d9f6c618c698127565/releases/6067a7f704dbdf149481f145/img/vector-1@2x.svg"
              />
              <img
                className="ellipse-56"
                src="https://anima-uploads.s3.amazonaws.com/projects/6067a6d9f6c618c698127565/releases/6067a7f704dbdf149481f145/img/ellipse-56@2x.svg"
              />
              <img
                className="ellipse-60"
                src="https://anima-uploads.s3.amazonaws.com/projects/6067a6d9f6c618c698127565/releases/6067a7f704dbdf149481f145/img/ellipse-60@2x.svg"
              />
              <img
                className="path-341"
                src="https://anima-uploads.s3.amazonaws.com/projects/6067a6d9f6c618c698127565/releases/6067a7f704dbdf149481f145/img/path-341@2x.svg"
              />
              <img
                className="rectangle-26"
                src="https://anima-uploads.s3.amazonaws.com/projects/6067a6d9f6c618c698127565/releases/6067a7f704dbdf149481f145/img/rectangle-26@2x.svg"
              />
              <img
                className="rectangle-27"
                src="https://anima-uploads.s3.amazonaws.com/projects/6067a6d9f6c618c698127565/releases/6067a7f704dbdf149481f145/img/rectangle-27@2x.svg"
              />
              <img
                className="rectangle-25-2"
                src="https://anima-uploads.s3.amazonaws.com/projects/6067a6d9f6c618c698127565/releases/6067a7f704dbdf149481f145/img/rectangle-25-2@2x.svg"
              />
              <img
                className="rectangle-25-3"
                src="https://anima-uploads.s3.amazonaws.com/projects/6067a6d9f6c618c698127565/releases/6067a7f704dbdf149481f145/img/rectangle-25-3@2x.svg"
              />
              <img
                className="group-22"
                src="https://anima-uploads.s3.amazonaws.com/projects/6067a6d9f6c618c698127565/releases/6067a7f704dbdf149481f145/img/group-22@2x.svg"
              />
            </div>
            <img
              className="group-23"
              src="https://anima-uploads.s3.amazonaws.com/projects/6067a6d9f6c618c698127565/releases/6067a7f704dbdf149481f145/img/group-23@2x.svg"
            />
          </div>
        </div>
        <div className="mid-content">
          <h1 className="title roboto-bold-black-24px">
            Customise your digest
          </h1>
          <div className="subtitle roboto-normal-black-20px">
            <span className="span">Select which </span>
            <span className="span1">parts </span>
            <span className="span">
              of each social media account you want to follow
            </span>
          </div>
          <div className="button-secondary border-className-1">
            {/* <div className="text valign-text-middle roboto-normal-black-18px">
              Learn More
            </div> */}
          </div>
        </div>
      </div>

      {/* <!--middle split--> */}
      <div className="mid-feature-split-left">
        <div className="mid-content">
          <h1 className="title roboto-bold-black-24px">
            Feature that is amazing
          </h1>
          <div className="subtitle roboto-normal-black-20px">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </div>
          <div className="button-secondary border-className-1">
            {/* <div className="text valign-text-middle roboto-normal-black-18px">
              Learn More
            </div> */}
          </div>
        </div>
        <div className="mid-overlap-group">
          <div className="upper-media">
            <div className="mid-media-object"></div>
          </div>
          <img
            className="undraw-confirmationreb6q5-1"
            src="https://anima-uploads.s3.amazonaws.com/projects/6067a6d9f6c618c698127565/releases/6067a7f704dbdf149481f145/img/undraw-confirmation-re-b6q5-1-1@2x.svg"
          />
        </div>
      </div>

      {/* <!--bottom banner--> */}
      <div className="testimonial">
        <h1 className="quote-text roboto-normal-black-24px">
          “Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt.”
        </h1>
        <img
          className="media-person"
          src="https://anima-uploads.s3.amazonaws.com/projects/6067a6d9f6c618c698127565/releases/6067a7f704dbdf149481f145/img/media-person@2x.svg"
        />
        <p className="person-name roboto-normal-black-14px">
          Maria Lopez, VP of Design at Meshery
        </p>
      </div>
    </>
  );
};
